import React, { useState } from "react";
import { Collapse } from "@blueprintjs/core";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import HtmlText from "components/HtmlText";
import { isNotEmpty } from "utils/validate";
import { CustomVariableValueStatus } from "store/recipe/custom-variables.utils";
import ChevronDownIcon from "icons/chevron_down.svg";
import * as styles from "./styles.module.scss";
const FormulaValue = ({ status = CustomVariableValueStatus.Default, title, value, subtitle, children, defaultOpened = false, className, }) => {
    const [contentCollapsed, setContentCollapsed] = useState(!defaultOpened);
    return (React.createElement("div", { className: classNames(styles.root, className) },
        React.createElement("div", { className: classNames(styles.status, styles[status]) }),
        React.createElement("div", { className: styles.header },
            React.createElement(TextTruncate, { className: styles.title, text: title }),
            React.createElement("div", { className: styles.details },
                isNotEmpty(value, true) && (React.createElement(HtmlText, { text: value, targetClassName: styles.value, targetTagName: "p" })),
                isNotEmpty(subtitle, true) && (React.createElement(HtmlText, { text: subtitle, targetClassName: styles.subtitle, targetTagName: "p" }))),
            React.createElement(ChevronDownIcon, { className: classNames(styles.chevron, { [styles.open]: !contentCollapsed }), onClick: () => setContentCollapsed(!contentCollapsed) })),
        React.createElement(Collapse, { keepChildrenMounted: true, isOpen: !contentCollapsed },
            React.createElement("div", { className: styles.content }, children))));
};
export default FormulaValue;
